var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "730CC393-EB5A-4270-9AB4-E4C37A2288DF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 1 105.777778 1 320 1 320 117 0 117"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.5%",
    y: "-17.2%",
    width: "125.0%",
    height: "169.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 20,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DSR-global-EU-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XSmall-Services-history-EU---2---Error-1",
    transform: "translate(-15.000000, -66.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 320,
    height: 644
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 50,
    width: 320,
    height: 594
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 8.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Banner-Copy-5",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Notification-Icon",
    transform: "translate(15.000000, 18.000000)",
    fill: "#D62D14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,16.7948847 C11.2879686,16.7948847 10.7779669,17.2616858 10.7779669,17.952312 C10.7779669,18.6441351 11.2879686,19.1252992 12,19.1252992 C12.7107995,19.1252992 13.2220331,18.6441351 13.2220331,17.952312 C13.2220331,17.2616858 12.7107995,16.7948847 12,16.7948847 L12,16.7948847 Z M12.5260163,15.5632481 C12.6652196,14.1197556 12.9276118,10.1663097 12.9276118,9.04000252 L12.9276118,8.43794885 L11.1019535,8.43794885 L11.1019535,9.04000252 C11.1019535,10.1663097 11.3655776,14.1197556 11.5047809,15.5632481 L12.5260163,15.5632481 Z M12,2.5 C11.5614478,2.5 11.1561566,2.72861283 10.9393442,3.0984629 L1.16061561,19.7237621 C0.945035168,20.0912183 0.946267056,20.5424594 1.16554316,20.9087187 C1.38481926,21.274978 1.78641482,21.5 2.22250325,21.5 L21.7774968,21.5 C22.2135852,21.5 22.6151807,21.274978 22.8344568,20.9087187 C23.0537329,20.5424594 23.0549648,20.0912183 22.8393844,19.7237621 L13.0606558,3.0984629 C12.8438434,2.72861283 12.4385522,2.5 12,2.5 L12,2.5 Z",
    id: "Warning"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationError);
export default __webpack_public_path__ + "static/media/notification-error.124f66d8a2182e0f7ddb5c448902db74.svg";
export { ForwardRef as ReactComponent };